

























































import {Component, Prop} from "vue-property-decorator";
import WarehouseTable from "@/modules/warehouses/shared/components/WarehouseTable/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {SiteTargetType} from "@/enums/type";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {LadingStatus} from "@/enums/status";

@Component({
    name: "StockInWaitExcel",
    components: {LadingStatusLabel, WarehouseTable}
})
export default class extends mixins(CommonMixin) {
    @Prop({required: true}) readonly billLadings!: any;
    LadingStatus = LadingStatus;
    siteTargetType = SiteTargetType;
}
